// accessing theme which is active in ThemeProvider
const publicLayoutStyle = (theme) => ({
  container: {
    display: 'flex',
    minHeight: '100vh',
  },
})

export default publicLayoutStyle
